export const compareString = (a, b) => a < b ? -1 : (a > b ? 1 : 0)
